<div class="list-page vo-profile">
    <lokos-page-header [label]="headerLeader" [breadcrumbs]="breadcrumbs">
    </lokos-page-header>

    <lokos-card> </lokos-card>
</div>

<section class="inner-master-wrp active">
    <div id="contentToConvert222">
        <div id="contentHeight">
            <div class="common-box p-3 sidebg" id="contentToConvert333333">
                <div class="certificate-sec">
                    <div class="row no-gutters">
                        <div class="col-8 col-md-8 col-sm-8 flex-column">
                            <img
                                src="./assets/img/three_column_logo.jpg"
                                alt=""
                            />
                        </div>
                    </div>
                    <div class="certificate-wrp-content">
                        <div class="certificate-bg-heading">
                            <span>Certificate</span> <br /><span
                                class="text-font-color"
                                >of
                                @if (shgKeyword) {
                                    <span>{{ shgKeyword }} </span>
                                }
                                {{ regType }} Registration</span
                            >
                        </div>

                        @if (regType === 'SHG') {
                            <div class="certificate-sm-heading">
                                {{ 'thisCertifySHG' | translate }}
                            </div>
                        }
                        @if (regType === 'VO') {
                            <div class="certificate-sm-heading">
                                {{ 'thisCertifyVillageOrg' | translate }}
                            </div>
                        }
                        @if (regType === 'CLF') {
                            <div class="certificate-sm-heading">
                                {{ 'thisCertifyClusterFederation' | translate }}
                            </div>
                        }
                        @if (regType === 'Member') {
                            <div class="certificate-sm-heading">
                                {{ 'thisCertify' | translate }}
                            </div>
                        }

                        <div class="row mb-1r">
                            <div>
                                <div class="full-border-btm full-border-width">
                                    <span class="border-dotted font-bold">
                                        {{ contName }}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="row mb-1r">
                            @if (regType === 'Member') {
                                <div class="">
                                    <div
                                        class="full-border-btm full-border-width"
                                    >
                                        <span>{{ 'of' | translate }} </span>
                                        <span class="font-bold">
                                            <q>{{ shgName }}</q>
                                        </span>
                                        <span>
                                            {{ 'shg(SHG)' | translate }}</span
                                        >
                                    </div>
                                </div>
                            }
                        </div>
                        <div class="row mb-1r">
                            <div>
                                <div class="full-border-btm">
                                    <span>
                                        {{ 'havingItsAddressAt' | translate }}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="row mb-1r">
                            @if (regType !== 'CLF') {
                                <div class="container-border">
                                    @if (
                                        regType === 'SHG' ||
                                        regType === 'Member'
                                    ) {
                                        <div class="full-border-btm">
                                            <span
                                                >{{ 'village' | translate }} :
                                            </span>
                                            <span class="font-bold">
                                                {{ villageName }}
                                            </span>
                                        </div>
                                    }
                                    <div class="full-border-btm">
                                        {{ 'gramPanchayat' | translate }} :
                                        <span class="font-bold">
                                            {{ panchayatName }}
                                        </span>
                                    </div>
                                    <div class="full-border-btm">
                                        {{ 'block' | translate }} :
                                        <span class="font-bold">
                                            {{ blockName }}
                                        </span>
                                    </div>
                                </div>
                            }
                        </div>

                        <div class="row mb-1r">
                            <div class="container-border">
                                @if (regType === 'CLF') {
                                    <div class="full-border-btm">
                                        <span>
                                            {{ 'block' | translate }} :</span
                                        >
                                        <span class="font-bold">
                                            {{ blockName }}
                                        </span>
                                    </div>
                                }
                                <div class="full-border-btm">
                                    <span>{{ 'district' | translate }} : </span>
                                    <span class="font-bold">
                                        {{ distName }}
                                    </span>
                                </div>
                                <div class="full-border-btm">
                                    <span>{{ 'state' | translate }} : </span>
                                    <span class="font-bold">
                                        {{ stateName }}
                                    </span>
                                </div>
                            </div>

                            <!-- <div class="">has been registered with DAY-NRLM.</div> -->
                        </div>
                        <div class="row mb-1r">
                            <div class="full-border-btm">
                                <span>
                                    {{ 'hasBeenRegistered' | translate }}
                                    @if (regType === 'Member') {
                                        <span>{{
                                            'asAShgMember' | translate
                                        }}</span>
                                    }
                                    {{ 'withDayNrlm' | translate }}:
                                </span>
                            </div>
                        </div>
                        <div class="row mb-1r">
                            <div class="container-border">
                                <div class="full-border-btm">
                                    <span class="font-bold">
                                        @if (regType === 'SHG') {
                                            {{ 'shgID' | translate }}
                                        }
                                        @if (regType === 'VO') {
                                            {{ 'voID' | translate }}
                                        }
                                        @if (regType === 'CLF') {
                                            {{ 'clfID' | translate }}
                                        }
                                        @if (regType === 'Member') {
                                            {{ 'shgMemberID' | translate }}
                                        }
                                        :
                                    </span>
                                    <span class="text-font-color font-bold">
                                        {{ shgCode || 'N/A' }}
                                    </span>
                                </div>
                                <div class="full-border-btm">
                                    <span class="font-bold">MIS Code : </span>
                                    <span class="text-font-color font-bold">
                                        {{ micCode || 'N/A' }}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="row mb-1r">
                            <div class="">
                                <div class="full-border-btm">
                                    @if (regType !== 'Member') {
                                        <span class="font-bold">
                                            {{ regType }}
                                            {{ 'formationDate' | translate }} :
                                        </span>
                                    }
                                    @if (regType === 'Member') {
                                        <span class="font-bold">
                                            {{ 'shgJoiningDate' | translate }} :
                                        </span>
                                    }
                                    <span class="text-font-color font-bold">
                                        {{ formationDate | date: 'dd-MM-yyyy' }}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="row mb-1r">
                            <div>
                                <div class="full-border-btm">
                                    <span>
                                        {{
                                            'certificateConfirmation'
                                                | translate
                                        }}
                                        @if (regType === 'Member') {
                                            <span>member</span>
                                        }
                                        @if (regType !== 'Member') {
                                            <span>{{ regType }}</span>
                                        }
                                        {{
                                            'registrationwithDAYNRLM'
                                                | translate
                                        }}:
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="row mb-4">
                            <div class="container-border">
                                <div class="full-border-btm">
                                    <span>{{ 'issuedOn' | translate }} : </span>
                                    <span
                                        style="width: auto; flex: unset"
                                        class="font-bold"
                                    >
                                        {{ todayData | date: 'dd-MM-yyyy' }}
                                    </span>
                                </div>
                                <div class="full-signature-btm">
                                    {{ 'signature' | translate }}
                                </div>
                            </div>
                        </div>
                        <div class="row mb-1r">
                            <div>
                                <div class="full-border-btm">
                                    <qrcode
                                        [qrdata]="dataToString"
                                        [width]="115"
                                        [errorCorrectionLevel]="'M'"
                                    ></qrcode>
                                </div>
                            </div>
                        </div>
                        <div class="row mb-1r">
                            <div>
                                <div class="full-border-btm">
                                    <p class="signature-para">
                                        {{ 'footerNote' | translate }}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 col-md-12 lokos-in">
                                <a href="https://lokos.in/" target="_blank"
                                    >www.lokos.in</a
                                >
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        @for (data of splitShgMembersListsData; track data; let i = $index) {
            <div class="common-box p-3" id="contentToConvert{{ i + 1 }}">
                <div class="certificate-sec-2">
                    <div class="row">
                        <div class="col-md-12 col-sm-12">
                            <div class="certificate-table-heading">
                                <span>Certificate of Registration for </span>
                                <span>
                                    {{ contName }}
                                </span>
                                ({{ regType }}) <br />
                                @if (regType === 'SHG') {
                                    <span> Member List</span>
                                }
                                @if (regType === 'VO') {
                                    <span>EC Member List</span>
                                }
                                @if (regType === 'CLF') {
                                    <span> EC Member List</span>
                                }
                                @if (regType === 'Member') {
                                    <span> Member List</span>
                                }
                            </div>
                        </div>
                    </div>
                    <div class="table-responsive">
                        <table
                            class="table-width table rounded-corners text-center mb-0 mt-3"
                        >
                            <thead>
                                <tr>
                                    <th>{{ 'serial_num' | translate }}</th>
                                    <th>{{ 'memberName' | translate }}</th>
                                    <th>{{ 'memberCode' | translate }}</th>
                                    <th>
                                        {{ 'fatherHusbandName' | translate }}
                                    </th>
                                    <th>
                                        {{ regType }}
                                        {{ 'designation' | translate }}
                                    </th>
                                    <th>Photo</th>
                                </tr>
                            </thead>
                            <tbody>
                                @for (
                                    member of data;
                                    track member;
                                    let i = $index
                                ) {
                                    <tr>
                                        <td>
                                            {{
                                                findIndex(member?.member_code) +
                                                    1
                                            }}
                                        </td>
                                        <td>{{ member?.member_name }}</td>
                                        <td>{{ member?.member_code }}</td>
                                        <td>
                                            @if (member?.relation_name !== '') {
                                                <span>{{
                                                    member?.relation_name
                                                }}</span>
                                            }
                                            @if (member?.relation_name === '') {
                                                <span>-</span>
                                            }
                                        </td>
                                        <td>{{ member?.mem_designation }}</td>
                                        <td
                                            class="text-center"
                                            style="width: 100px"
                                        >
                                            <img
                                                *ngIf="
                                                    member?.imagePath &&
                                                        !member?.imageLoadFailed;
                                                    else avatarPlaceholder
                                                "
                                                [src]="member?.imagePath"
                                                alt="Member Photo"
                                                class="member-photo"
                                                style="
                                                    width: 100px;
                                                    height: 100px;
                                                    object-fit: cover;
                                                "
                                                (error)="
                                                    onMemberImageError(member)
                                                "
                                            />

                                            <ng-template #avatarPlaceholder>
                                                <div class="img-box">
                                                    <img
                                                        src="https://cdn.lokos.in/assets/img/avatar.png"
                                                        class="img-thumbnail-profile"
                                                        alt="image"
                                                        style="
                                                            width: 100px;
                                                            height: 100px;
                                                            object-fit: cover;
                                                        "
                                                    />
                                                </div>
                                            </ng-template>
                                            <!-- @if (member?.member_document) {
                                                <div class="img-box">
                                                    <img
                                                        src="{{
                                                            member?.imageData
                                                        }}"
                                                        class="img-thumbnail-profile"
                                                        alt=""
                                                        (error)="
                                                            onImgError($event)
                                                        "
                                                    />
                                                </div>
                                            }
                                            @if (
                                                !member?.member_document &&
                                                member?.member_image
                                            ) {
                                                <div class="img-box">
                                                    <img
                                                        src="{{
                                                            member?.imageData
                                                        }}"
                                                        class="img-thumbnail-profile"
                                                        alt=""
                                                        (error)="
                                                            onImgError($event)
                                                        "
                                                    />
                                                </div>
                                            }
                                            @if (
                                                !member?.member_document &&
                                                !member?.member_image
                                            ) {
                                                <div class="img-box">
                                                    <img
                                                        src="https://cdn.lokos.in/assets/img/avatar.png"
                                                        class="img-thumbnail-profile"
                                                        alt="image"
                                                    />
                                                </div>
                                            } -->
                                        </td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        }
    </div>
    <div class="bottom-container">
        <lokos-button
            [label]="'Download'"
            [type]="'primary'"
            (afterClick)="convertToPDF()"
        ></lokos-button>
        <lokos-button
            [label]="'Print'"
            [type]="'primary'"
            (afterClick)="printPage()"
        ></lokos-button>
    </div>
</section>
